export default "__VITE_ASSET__3b5169b5__"